(function(){
  var banner = document.getElementById('promo-banner');
  if(!banner) return;

  var endStr = banner.getAttribute('data-end');
  var storageKey = 'kalima_promo_closed_' + endStr;
  if(localStorage.getItem(storageKey) === '1'){
    banner.style.display = 'none';
    return;
  }

  var end = new Date(endStr).getTime();
  var elH = document.getElementById('pc-h');
  var elM = document.getElementById('pc-m');
  var elS = document.getElementById('pc-s');

  function pad(n){ return String(n).padStart(2, '0'); }

  function tick(){
    var now = Date.now();
    var diff = end - now;
    if(diff <= 0){
      banner.style.display = 'none';
      clearInterval(timer);
      return;
    }
    var totalSeconds = Math.floor(diff / 1000);
    var hours = Math.floor(totalSeconds / 3600);
    var minutes = Math.floor((totalSeconds % 3600) / 60);
    var seconds = totalSeconds % 60;
    if(elH) elH.textContent = pad(hours);
    if(elM) elM.textContent = pad(minutes);
    if(elS) elS.textContent = pad(seconds);
  }

  tick();
  var timer = setInterval(tick, 1000);

  var closeBtn = document.getElementById('promo-close');
  if(closeBtn){
    closeBtn.addEventListener('click', function(){
      banner.style.display = 'none';
      localStorage.setItem(storageKey, '1');
      clearInterval(timer);
    });
  }
})();
